import { useNavigate } from 'react-router-dom';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ArrowLeft } from 'lucide-react';
import { usersApi } from '../../lib/api/users';
import { Card, CardContent } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';
import { UserForm, UserFormData } from '../../components/users/UserForm';
import { toast } from '../../stores/toastStore';

export function NewUserPage() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const createUser = useMutation({
    mutationFn: (data: UserFormData) => usersApi.create(data as any),
    onSuccess: () => {
      toast.success('User created successfully');
      queryClient.invalidateQueries({ queryKey: ['users'] });
      navigate('/users');
    },
    onError: (error: any) => {
      toast.error(error.response?.data?.error?.message || 'Failed to create user');
    },
  });

  const handleSubmit = async (data: UserFormData) => {
    await createUser.mutateAsync(data);
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-4">
        <Button variant="ghost" size="sm" onClick={() => navigate('/users')}>
          <ArrowLeft className="h-4 w-4" />
        </Button>
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Create New User</h1>
          <p className="text-gray-600">Add a new team member to the console</p>
        </div>
      </div>

      <Card>
        <CardContent className="p-6">
          <UserForm
            onSubmit={handleSubmit}
            onCancel={() => navigate('/users')}
            isLoading={createUser.isPending}
          />
        </CardContent>
      </Card>
    </div>
  );
}
